import { visserApi } from "./visserApi";
import { convertModelToFormData, convertModelToFormDataWithList } from "./helpers";
const getAllPurchaseInvoiceStatus = async () => {
    return await visserApi.get('PurchaseInvoice/GetAllPurchaseInvoiceStatus');
};
const getOrdersList = async (orderNumber) => {
    return await visserApi.get(`PurchaseInvoice/GetOrdersList/${orderNumber}`);
};
const getPurchaseInvoiceNumber = async () => {
    return await visserApi.get('PurchaseInvoice/PurchaseInvoiceNumber');
};
const createPurchaseInvoice = async (createdPurchaseInvoice) => {
    const formData = convertModelToFormDataWithList(createdPurchaseInvoice);
    return visserApi.postForm('PurchaseInvoice/Create', formData);
};
const getPurchaseInvoiceById = (purchaseInvoiceId) => {
    return visserApi.get(`PurchaseInvoice/GetPurchaseInvoiceById/${purchaseInvoiceId}`);
};
const updatePurchaseInvoice = async (updatePurchaseInvoice) => {
    const formData = convertModelToFormData(updatePurchaseInvoice);
    return visserApi.postForm('PurchaseInvoice/Update', formData);
};
const deletePurchaseInvoiceById = async (id) => {
    return await visserApi.delete(`PurchaseInvoice/Delete/${id}`);
};
const getAllPurchaseInvoices = async (request) => {
    const filter = `&filter=${request.filter ? request.filter : ''}`;
    const SortColumn = `&SortColumnKey=${request.sortColumnKey}`;
    const SortDirection = `&SortDirection=${request.sortDirection}`;
    const columnWiseFilter = request || {};
    return visserApi.post(`PurchaseInvoice/GetAll?pageNumber=${request.pageNumber}&pageSize=${request.pageSize}${filter}${SortColumn}${SortDirection}`, columnWiseFilter);
};
const generatePurchaseInvoicePdf = async (purchaseInvoice) => {
    const response = await visserApi.post(`PurchaseInvoice/GeneratePurchaseInvoicePdf`, purchaseInvoice);
    return response.data;
};
const downloadPurchaseInvoiceAttachment = async (purchaseInvoiceAttachment) => {
    const response = await visserApi.post(`PurchaseInvoice/DownloadPurchaseInvoiceAttachment`, purchaseInvoiceAttachment);
    return response.data;
};
const PurchaseInvoiceApi = {
    getAllPurchaseInvoiceStatus,
    getOrdersList,
    getPurchaseInvoiceNumber,
    createPurchaseInvoice,
    getPurchaseInvoiceById,
    updatePurchaseInvoice,
    deletePurchaseInvoiceById,
    getAllPurchaseInvoices,
    generatePurchaseInvoicePdf,
    downloadPurchaseInvoiceAttachment
};
export default PurchaseInvoiceApi;
